export type SellerProfileUi = {
  sellerId?: string;
  title: string;
};

export const initialState: SellerProfileUi = {
  title: '',
};
